<template>
  <div>
    <div class="sync flex flex-between">
      <div class="refresh flex flex-center item-center flex-column">
        <img
          src="https://imgcdn.hemiao100.com/hemiaoBase/a5af5dd9-1169-4a27-a8cb-6b4b43208d7e.png"
          alt=""
        />
      </div>
      <div class="titlebox">
        <p class="title">同步ERP收银系统商品品牌</p>
        <p class="describe">
          已完成初始化设置，开启同步后，品牌列表会直接同步ERP系统商品品牌，不可单独设置，且开启后不可更改。开启后若需要增加/删除品牌，请在ERP系统中修改后，系统会在24小时内自动同步，或者点击手动同步按钮，等待更新。（注，品牌描述内容可以修改维护）
        </p>
      </div>

      <el-switch class="switch" disabled v-model="value"> </el-switch>
    </div>

    <slot name="header"></slot>
    <el-card shadow="never" class="hm-content">
      <slot />
    </el-card>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Boolean }
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {}
};
</script>

<style scoped lang="scss">
// 标题全局样式
.hm-headline {
  padding: 0.5rem 0;
  margin-bottom: 10px;
  .headline {
    border-left: 3px solid#E50065;
    padding-left: 10px;
    font-size: 14px;
    color: #333;
  }
}
.hm-content {
  margin-bottom: 64px;
}
.sync {
  background: rgba(255, 248, 225, 1);
  border: 1px solid rgba(248, 216, 117, 1);
  // background: #e8f5ff;
  // border: 1px solid #0081e5;
  // color: #0081e5;
  padding: 10px;
  .refresh {
    // width: 28px;
    // height: 24px;
    // margin-top: 20px;
    // margin-left: 20px;

    img {
      width: 40px;
      // height: 100%;
    }
  }
  .title {
    // height: 16px;
    line-height: 18px;
    font-weight: bold;
    color: rgba(90, 83, 73, 1);
  }
  .describe {
    font-size: 12px;
    line-height: 16px;
  }
  .switch {
    margin-top: 9px;
    margin-right: 21px;
  }
}
</style>
